import { Component } from '@angular/core';
import { EntityCrud } from '../../../shared/working/entity-crud/entity-crud';
import { ENTITY_CONFIGS } from '../entity-configs';

@Component({
  imports: [EntityCrud],
  selector: 'app-md-a5acf579',
  styleUrl: './md-a5acf579.css',
  templateUrl: './md-a5acf579.html',
})
export class MdA5acf579 {
  readonly config = ENTITY_CONFIGS['a5acf579'];
}
